
































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { Component } from 'vue-property-decorator';
import { RepairOrderViewModel } from '@/models/fixedops/repairorder';
import { NotificationHelper as _notification } from '@/helper/notifications.helper';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import { FileHelper as _file } from '@/helper/file.helper';
import { Utils } from '@/helper/utils';
import { paymentService } from '@/shared';
import { IPaymentDialog } from '@/models/paymentDialog';

@Component({
  components: {
    service: () => import('@/components/repairorder/detail.service.vue'),
    AppDialog: () => import('@/components/common/app.dialog.vue'),
    CenposPayment: () => import('@/components/common/cenpos.payment.vue'),
    SquarePayment: () => import('@/components/common/square.payment.vue'),
    CloverPayment: () => import('@/components/common/clover.payment.vue'),
    PaymentDialog: () => import('@/components/common/payment.dialog.vue')
  },
  computed: {
    customerAddress: {
      get() {
        this.customerAddressValue = this.roDetails.customerStreetAddress1 +
          ' ' +
          this.roDetails.customerStreetAddress2;
        return (

          this.roDetails.customerStreetAddress1 +
          ' ' +
          this.roDetails.customerStreetAddress2
        );
      },
    },
    partSaleApprovedPaymentDetail: {
      get() {
        const partsalesPayment = this.roDetails.paymentDetail.paymentResponses.filter(
          (x) => x.status == 'Approved'
        );
        return partsalesPayment;
      },
    },
  },
})
export default class RepairOrderDetailPage extends Base {
  public paymentDialog: boolean = false;
  public customerAddressValue: string = '';
  public roDetails: any = {};
  public constants: any = {
    roNumber: '',
  };
  public flags: any = {
    paymentApproved: false,
    isClosed: false,
    showDetails: false,
  };
  public isPayrocPaymentInitiated: boolean = false;
  public cenposUrl: string = Utils.WEB_BASE_URL + '/serverpay/cenpos';
  public manualPaymentPopup: IDialogOption = {
    width: 400,
    title: this.$parent.$t(
      'repairOrderCpay.manualPaymentDialog.title'
    ) as string,
    model: false,
    loading: false,
    action: {
      color: 'success',
      icon: 'fas fa-check',
      text: this.$parent.$t(
        'repairOrderCpay.manualPaymentDialog.agree'
      ) as string,
      disable: false,
    },
    onAction: (): void => {
      this.payManually();
    },
  };

  public squareDialog: boolean = false;
  public isCloverDialog: boolean = false;
  public cenposDialog: boolean = false;
  public cenposConfirmDialog: boolean = false;
  public cenposStatus: boolean = false;
  public currentUrl: string = '';
  public loading: boolean = false;
  public requestProgress: boolean = false;
  public loggedInUserEmail: string = '';
  public loggedInUserId: string = '';
  public firstName: string = '';

  public async mounted() {

    this.$watch("roDetails", (newVal) => {
      this.paymentOptions.recordKey = newVal.roNumber;
      this.paymentOptions.customerKey = newVal.customerKey;
      this.paymentOptions.vin = newVal.vin;
      this.paymentOptions.amount = Number(newVal.displayDueAmount);
      this.paymentOptions.city = newVal.customerCity;
      this.paymentOptions.state = newVal.customerState;
      this.paymentOptions.zipcode = newVal.customerZip;
      this.paymentOptions.transactionHeaderId = newVal.transactionHeaderId;
      this.paymentOptions.lastPaymentDetailId = newVal.lastPaymentDetailId;
      this.paymentOptions.customerEmail = newVal.customerEmail1;
      this.paymentOptions.merchantEmail = newVal.merchantEmail;
      this.paymentOptions.amountWithServiceCharges = newVal.amountWithServiceCharges;
      this.paymentOptions.bypassReason = newVal.byPassReason;
      this.paymentOptions.isOverrideCCFeeApplied = newVal.isOverrideCCFeeApplied;
      this.paymentOptions.tenantId = newVal.tenantId;
      this.paymentOptions.enterpriseId = newVal.enterpriseId;
      this.paymentOptions.storeId = newVal.storeId;
      this.paymentOptions.firstName = newVal.customerName;
    },
      {
        deep: true, // Enables deep watching for nested changes in roDetails
      }
    );
    this.$watch("customerAddressValue", (newVal) => {
      this.paymentOptions.address = newVal;
    });

    if (this.$route.params.roNumber) {
      this.constants.roNumber = this.$route.params.roNumber;
      this.constants.txId = this.$route.params.txId;
      this.constants.detailId = this.$route.params.detailId;
      await this.getOrderDetail();
    }
    this.currentUrl = window.location.href;


  }

  public updateCenposDialog(cenposDialogValue) {
    this.cenposDialog = cenposDialogValue;
  }

  public updateSquareDialog(squareDialogValue) {
    this.squareDialog = squareDialogValue;
  }

  public updateCloverDialog(cloverDialogVaue) {
    this.isCloverDialog = cloverDialogVaue;
  }

  public async getOrderDetail(): Promise<void> {
    try {
      this.loading = true;
      const response = await paymentService.getRepairOrderDetails(
        this.constants.roNumber,
        this.constants.txId,
        this.constants.detailId
      );
      this.roDetails = response;
      this.loggedInUserEmail = this.userSession.email;
      this.loggedInUserId = this.userSession.sessionUserId;

      if (this.roDetails.finalCloseDate) {
        this.flags.isClosed = true;
      }
      this.flags.showDetails = true;

      if (
        this.roDetails.paymentDetail &&
        this.roDetails.paymentDetail.paymentResponses
      ) {
        this.roDetails.paymentDetail.paymentResponses.forEach((resp) => {
          resp.customerName = this.roDetails.customerName;
          resp.roNumber = this.roDetails.roNumber;
        });

        if (
          this.roDetails.paymentDetail &&
          this.roDetails.paymentDetail.paymentResponses &&
          this.roDetails.paymentDetail.paymentResponses.length > 0
        ) {
          const approvedPayment = this.roDetails.paymentDetail.paymentResponses.find(
            (pay) => {
              return (
                pay.status === 'Approved' && pay.id == this.constants.detailId
              );
            }
          );
          const payrocInProcessPayment = this.roDetails.paymentDetail.paymentResponses.find(
            (pay) => {
              return (
                pay.status === 'InProcess' && pay.id == this.constants.detailId
              );
            }
          );
          if (approvedPayment && approvedPayment.status === 'Approved') {
            // approvedPayment
            this.flags.paymentApproved = true;
          }
          if (payrocInProcessPayment && payrocInProcessPayment.status === 'InProcess') {

            this.isPayrocPaymentInitiated = true;
            this.showAlert(true, "Payment is in process, Please check the final status in Payment report.");
          }
          // if (this.roDetails.paymentDetail.status === 'Approved') {
          //   // approvedPayment
          //   this.flags.paymentApproved = true;
          // }
        }
      }
    } finally {
      this.loading = false;
    }
  }

  public async ValidationCenpos(): Promise<void> {
    const validateMessage = this.validatePayment();
    if (validateMessage == '') {
      if (this.roDetails.defaultPaymentProvider == 'Cenpos') {
        this.cenposConfirmDialog = false;
        this.cenposDialog = true;
      } else {
        this.cenposConfirmDialog = false;
        this.squareDialog = true;
      }
    } else {
      const message =
        'Can not Make the payment because, Customer' +
        validateMessage +
        ' are Empty.';
      this.showAlert(false, message);
    }
  }

  public validatePayment(): string {
    let message = '';
    if (
      this.roDetails.customerCity == undefined ||
      this.roDetails.customerCity == ''
    ) {
      message += ' City';
    }
    if (
      this.roDetails.customerKey == undefined ||
      this.roDetails.customerKey == ''
    ) {
      message += ' CustomerKey';
    }

    if (
      this.roDetails.customerState == undefined ||
      this.roDetails.customerState == ''
    ) {
      message += ' State';
    }
    if (
      this.roDetails.customerStreetAddress1 == undefined &&
      this.roDetails.customerStreetAddress1 == ''
    ) {
      message += ' Address';
    }

    return message;
  }

  public parseVendorResponse(vendorString): any {
    return JSON.parse(vendorString || '{}');
  }

  public async payManually(): Promise<void> {
    if (
      Number(this.roDetails.displayDueAmount) === 0 ||
      isNaN(Number(this.roDetails.displayDueAmount))
    ) {
      this.showAlert(false, this.$t('repairOrderCpay.alertDueAmountIsZero'));
      return;
    }

    try {
      this.manualPaymentPopup.loading = true;
      // tslint:disable-next-line:max-line-length
      const response = await paymentService.customerRoPayment(
        this.constants.roNumber,
        this.constants.txId,
        this.constants.detailId,
        this.roDetails.displayDueAmount
      );
      if (response.redirectUri) {
        location.href = response.redirectUri.toString();
      }
    } finally {
      this.manualPaymentPopup.loading = false;
      this.manualPaymentPopup.model = false;
    }
  }

  public async downloadReceipt(payment): Promise<void> {
    try {
      this.requestProgress = true;
      const response = await paymentService.downloadReceipt(
        this.roDetails.paymentDetail.transactionHeaderId,
        payment.id
      );
      const bytes = _file.base64ToArrayBuffer(response.fileContent);
      _file.downloadBytes(bytes, '', response.fileDownloadName);
    } finally {
      this.requestProgress = false;
    }
  }
  public openPaymentModal() {
    if (this.roDetails.defaultPaymentProvider == 'Vantiv') {
      this.manualPaymentPopup.model = true;
    } else if (this.roDetails.defaultPaymentProvider == 'Cenpos') {
      if (this.roDetails.isCenposConfigured) {
        const validateMessage = this.validatePayment();
        if (validateMessage == '') {
          this.paymentDialog = true;
          this.$root.$emit('validatePaymentProvider');
        } else {
          const message =
            'Can not Make the payment because, Customer' +
            validateMessage +
            ' are Empty.';
          this.showAlert(false, message);
        }
      } else {
        this.showAlert(
          false,
          'Cenpos Payment not configured, please contact admin.'
        );
      }
    } else {
      this.paymentDialog = true;
      this.$root.$emit('validatePaymentProvider');
    }

  }

  public paymentOptions: IPaymentDialog = {
    id: "ROAnonymous",
    url: window.location.href,
    recordKey: this.roDetails.roNumber,
    customerKey: this.roDetails.customerKey,
    vin: this.roDetails.vin,
    amount: Number(this.roDetails.displayDueAmount),
    address: this.customerAddressValue,
    city: this.roDetails.customerCity,
    state: this.roDetails.customerState,
    zipcode: this.roDetails.customerZip,
    transactionHeaderId: this.roDetails.transactionHeaderId,
    lastPaymentDetailId: this.roDetails.lastPaymentDetailId,
    customerEmail: this.roDetails.customerEmail1,
    merchantEmail: this.roDetails.merchantEmail,
    amountWithServiceCharges: this.roDetails.amountWithServiceCharges,
    showTextField: true,
    recordIdentifier: "RO",
    type: "1",
    bypassReason: this.roDetails.byPassReason,
    isOverrideCCFeeApplied: this.roDetails.isOverrideCCFeeApplied,
    tenantId: this.roDetails.tenantId,
    enterpriseId: this.roDetails.enterpriseId,
    storeId: this.roDetails.storeId,
    firstName: this.roDetails.customerName
  };
  public updatePaymentDialog(paymentDialogValue) {
    this.paymentDialog = paymentDialogValue;
  }

}
